<table class="specifikation">
  @for (linje of linjer; track linje) {
    <tr [class]="linje.cssClasses">
      <td>{{ linje.tekst }} <small [innerHTML]="linje.tekst2"></small></td>
      <td>{{ linje.beloeb | number: "1.0-0" }} {{ linje.beloebSuffix }}</td>
    </tr>
  }
</table>
